const typescript = __non_webpack_require__('typescript'); module.exports = typescript;